import { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { CrossInBox } from '../../../../svgIcons';

class RejectTransferDialog extends Component {
    renderHeader = () => {
        return (
            <div className="mt-2 formHeadingInter">
                <div className="mb-3">
                    <CrossInBox bgcolor={'#BF0031'} color={'white'} />
                </div>
                <p style={{ fontWeight: 'bold', fontSize: 20 }}>Reject Admission Change</p>
            </div>
        );
    };

    renderFooter = () => {
        const { onReject, onCancel } = this.props;
        
        return (
            <div className="flex justify-content-center">
                <Button
                    className="formSubmitButton px-6"
                    style={{ border: 0 }}
                    onClick={onReject}
                >
                    <p className="formSubmitButtonText">Reject</p>
                </Button>
                <Button 
                    className="formCancelButton px-4" 
                    style={{ backgroundColor: '#F4F5F6', border: 0 }} 
                    onClick={onCancel}
                >
                    <p className="formCancelButtonText">Cancel</p>
                </Button>
            </div>
        );
    };

    render() {
        const { visible, onHide, rowData } = this.props;

        return (
            <Dialog
                visible={visible}
                draggable={false}
                closeOnEscape={false}
                style={{ width: 400 }}
                dismissableMask={false}
                closable={false}
                header={this.renderHeader}
                footer={this.renderFooter}
                onHide={onHide}
            >
                <p className="topicName ml-6" style={{ color: 'black', alignSelf: 'center', paddingBottom: 10 }}>
                    <p>Enrollment No: {rowData?.user_info?.enrollmentId}</p>
                    <p>Student Name : {rowData?.user_info?.firstName ? `${rowData?.user_info?.firstName} ${rowData?.user_info?.lastName}` : rowData?.user_info?.given_name}</p>
                    <p>Branch Name: {rowData.user_info?.branchName}</p>
                    <p>Phone number : {rowData?.user_info?.parentContactNo}</p>
                    <p>Request Raised by : {rowData?.requestRaisedByName?.slice(3)}</p>
                </p>
            </Dialog>
        );
    }
}

export default RejectTransferDialog;
